import React, { Component } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';

import styles from '../../search.scss';

class SearchLocation extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.focusInput = this.focusInput.bind(this);
    }

    focusInput() {
        this.locationinput.focus();
    }

    render() {
        const {
            value,
            geoLocation,
            onChange,
            onSelect,
            className,
            onCurrentLocationClick,
            handleClearClick,
            'data-testid': dataTestId,
        } = this.props;

        console.log('SearchLocation', value);

        const searchOptions = {
            types: ['(regions)'], // https://developers.google.com/places/supported_types#table3
        };

        return (
            <PlacesAutocomplete
                value={value}
                onChange={onChange}
                onSelect={onSelect}
                searchOptions={searchOptions}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div className={`search-autocomplete-root d-block`}>
                        <input
                            ref={(elem) => { this.locationinput = elem; }}
                            {...getInputProps({
                                placeholder: 'City, State, Country, Zip code...',
                                className,
                            })}
                            data-testid={dataTestId}
                        />
                        {value && value.length > 0 && (
                            <span
                                className={`form-control-feedback fas fa-times-circle ${styles.clearInput}`}
                                onClick={() => handleClearClick(this.focusInput)}
                                data-testid={dataTestId && `${dataTestId}.clear-btn`}
                            />
                        )}
                        <div className="autocomplete-dropdown-container search-autocomplete-container" data-testid={dataTestId && `${dataTestId}.dropdown`}>
                            {loading && <div data-testid={dataTestId && `${dataTestId}.loading`}>Loading...</div>}
                            {suggestions && suggestions.length > 0 && geoLocation &&
                                <div className="current-location" onMouseDown={onCurrentLocationClick} data-testid={dataTestId && `${dataTestId}.current-location-option`}>Current location</div>}
                            {suggestions.map((suggestion, i) => {
                                const classNm = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                            className: classNm,
                                        })}
                                        data-testid={dataTestId && `${dataTestId}.suggestion-${i}`}
                                    >
                                        <span data-testid={dataTestId && `${dataTestId}.suggestion-${i}.description`}>{suggestion.description}</span>
                                    </div>
                                );
                            })}
                            {!!(suggestions && suggestions.length) && (
                                <div className="powered-by-google" />
                            )}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
        );
    }
}

export default SearchLocation;
